import React, { useState, useEffect } from "react";
import { Spin, Alert, Table, Pagination } from "antd";
import TSReactTable from "../common/TSReactTable";
import propTypes from "prop-types";
import { GET } from "../../utils/HttpClient";
import { useTranslation } from "react-i18next";

const ReportDetail = React.forwardRef((props, ref) => {
  const { reportUrl, isCustomSetData, customSetData, columns } = props;

  const { t } = useTranslation();

  const [data, setData] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [totalData, setTotalData] = React.useState(0);

  const refetch = async (queryString) => {
    setIsLoading(true);
    setErrorMessages(false);
    try {
      const response = await GET(`${reportUrl}?${queryString}`);
      let data = response.data;
      setTotalData(response.data.length);
      if (isCustomSetData == true) {
        data = customSetData(response.data);
      }
      setData(data);
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setIsLoading(false);
    }
  };

  React.useImperativeHandle(ref, () => ({
    refetch: refetch,
  }));

  React.useEffect(() => {
    console.log(data);
  }, [data]);

  React.useEffect(() => {
    console.log(totalData);
  }, [totalData]);

  return (
    <div style={{ position: "relative" }}>
      {errorMessages && (
        <Alert
          message={t("error")}
          description={errorMessages}
          type="error"
          showIcon
          style={{ marginBottom: 20 }}
        />
      )}
      <Spin spinning={isLoading} tip="กำลังโหลด...">
        <Table
          style={{ marginTop: "20px" }}
          scroll={{ x: 1000 }}
          dataSource={data}
          columns={columns}
          pagination={{
            size: "small",
            showSizeChanger: true,
            position: ["bottomCenter"],
            showTotal: (total) => ` Total ${total} rows`,
          }}
          rowClassName={(record) =>
            record.good_woods > 0 || record.total_volume > 0
              ? "highlight-row"
              : ""
          }
          bordered
        />
      </Spin>
    </div>
  );
});

export default React.memo(ReportDetail);

ReportDetail.propTypes = {
  reportUrl: "",
  isCustomSetData: false,
  customSetData: () => null,
  columns: [],
};

ReportDetail.defaultProps = {
  reportUrl: propTypes.string,
  isCustomSetData: propTypes.bool,
  customSetData: propTypes.func,
  columns: propTypes.array,
};
